import { faFlag } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Space, Typography } from 'antd';
import { useState } from 'react';
import GeneralHelper from '../../helpers/general';

const { Link } = Typography;

const LocationPopup = ({ locationId, pointOfInterestId, remoteId, history }) => {
	const query = GeneralHelper.getParamsFromUrl();
	const id = locationId || pointOfInterestId;
	const generalDefectUrl = remoteId
		// ? `https://maximo.ust.hk/maximo/ui/maximo.jsp?event=loadapp&value=ust_drs4s&additionalevent=insert&additionaleventvalue=location=${encodeURIComponent(remoteId)}`
		? `https://maximo.ust.hk/maximo/ui/maximo.jsp?event=loadapp&value=ust_drs4s&additionalevent=insert&additionaleventvalue=ust_spaceid=${encodeURIComponent(remoteId)}`
		: null;
	const labDefectUrl = remoteId
		// ? `https://maximo.ust.hk/maximo/ui/maximo.jsp?event=loadapp&value=ust_ldrs4s&additionalevent=insert&additionaleventvalue=location=${encodeURIComponent(remoteId)}`
		? `https://maximo.ust.hk/maximo/ui/maximo.jsp?event=loadapp&value=ust_ldrs4s&additionalevent=insert&additionaleventvalue=ust_spaceid=${encodeURIComponent(remoteId)}`
		: null;

	const [hoverStates, setHoverStates] = useState({
		start: false,
		end: false,
		generalDefect: false,
		labDefect: false
	});

	const handleSetPointOnClick = (id, start = true) => {
		if (!id) return;

		let queryObject = { ...query, id };

		if (start) {
			queryObject.start = id;
		}

		if (!start) {
			queryObject.end = id;
		}

		const queryString = GeneralHelper.objectToQueryString(queryObject);
		history.push(`/location/directions?${queryString}`);
	};

	const handleMouseEnter = (key) => {
		setHoverStates((prev) => ({ ...prev, [key]: true }));
	};

	const handleMouseLeave = (key) => {
		setHoverStates((prev) => ({ ...prev, [key]: false }));
	};

	return (
		<Space
			direction="vertical"
			align="start"
			style={{
				width: '100%',
				display: 'block'
			}}
		>
			<div
				onClick={() => handleSetPointOnClick(id, true)}
				onMouseEnter={() => handleMouseEnter('start')}
				onMouseLeave={() => handleMouseLeave('start')}
				style={{
					width: '100%',
					padding: '8px 12px',
					cursor: 'pointer',
					backgroundColor: hoverStates.start ? '#EEEEEE' : 'transparent',
					boxSizing: 'border-box'
				}}
			>
				<Button
					type="link"
					style={{
						width: '100%',
						padding: 0,
						margin: 0,
						height: 'fit-content',
						color: '#333333',
						textAlign: 'left',
						display: 'block'
					}}
				>
					Set Start point
				</Button>
			</div>

			<div
				onClick={() => handleSetPointOnClick(id, false)}
				onMouseEnter={() => handleMouseEnter('end')}
				onMouseLeave={() => handleMouseLeave('end')}
				style={{
					width: '100%',
					padding: '8px 12px',
					cursor: 'pointer',
					backgroundColor: hoverStates.end ? '#EEEEEE' : 'transparent',
					boxSizing: 'border-box'
				}}
			>
				<Button
					type="link"
					style={{
						width: '100%',
						padding: 0,
						margin: 0,
						height: 'fit-content',
						color: '#333333',
						textAlign: 'left',
						display: 'block'
					}}
				>
					Set End point
				</Button>
			</div>

			{remoteId && (
				<>
					<Link
						href={generalDefectUrl}
						target="_blank"
						style={{ width: '100%', display: 'block' }}
					>
						<div
							onMouseEnter={() => handleMouseEnter('generalDefect')}
							onMouseLeave={() => handleMouseLeave('generalDefect')}
							style={{
								padding: '8px 12px',
								cursor: 'pointer',
								backgroundColor: hoverStates.generalDefect ? '#EEEEEE' : 'transparent',
								boxSizing: 'border-box',
								display: 'flex',
								alignItems: 'center',
								gap: 10,
								width: '100%'
							}}
						>
							<span style={{ color: '#333333', flex: 1 }}>Report General Defect</span>
							<FontAwesomeIcon
								icon={faFlag}
								width={10}
							/>
						</div>
					</Link>

					<Link
						href={labDefectUrl}
						target="_blank"
						style={{ width: '100%', display: 'block' }}
					>
						<div
							onMouseEnter={() => handleMouseEnter('labDefect')}
							DOJ
							onMouseLeave={() => handleMouseLeave('labDefect')}
							style={{
								padding: '8px 12px',
								cursor: 'pointer',
								backgroundColor: hoverStates.labDefect ? '#EEEEEE' : 'transparent',
								boxSizing: 'border-box',
								display: 'flex',
								alignItems: 'center',
								gap: 10,
								width: '100%'
							}}
						>
							<span style={{ color: '#333333', flex: 1 }}>Report Lab Defect</span>
							<FontAwesomeIcon
								icon={faFlag}
								width={10}
							/>
						</div>
					</Link>
				</>
			)}
		</Space>
	);
};

export default LocationPopup;